export default {
    ROLE_ADCREATE: 'ROLE_ADCREATE',
    ROLE_ADMIN: 'ROLE_ADMIN',
    ROLE_CONTENT_MANAGER: 'ROLE_CONTENT_MANAGER',
    ROLE_SUPPORT: 'ROLE_SUPPORT',
}
